export enum UserProvider {
    "GFL" = "GFL",
    "INTERNAL" = "INTERNAL",
    "KOPJRA" = "KOPJRA",
    "COP" = "COP",
}

export interface User {
    userId: string;
    email: string;
    firstname: string;
    lastname: string;
    provider: UserProvider;
}

export type FullUser = User & {
    consumedCredits: number;
    crmid?: string;
    externalId?: string;
};
